import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { DS } from '../../components/ds';
import { BlogContextProvider, useBlogContext } from '../../contexts/BlogContext';
import { ArticleDetail } from '../../components/sections/blog/ArticleDetail';
import { BlogBreadcrumb } from '../../components/sections/blog/BlogBreadcrumb';
import { useDocumentMeta } from '../../hooks/useDocumentMeta';
function truncate(text: string, max: number) {
  return text.length > max ? `${text.slice(0, max)}…` : text;
}
function ArticleDetailPageContent() {
  const {
    id
  } = useParams<{
    id: string;
  }>();
  const navigate = useNavigate();
  const {
    articles
  } = useBlogContext();
  const article = articles.find(a => a.id === Number(id));
  useDocumentMeta({
    title: article ? article.title : 'Artículo no encontrado',
    description: article ? article.excerpt : 'El artículo que buscas no está disponible en el blog de Alinova.',
    path: `/blog/${id ?? ''}`
  });
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'auto'
    });
  }, [id]);
  const goToArticles = () => navigate('/blog');
  const goHome = () => navigate('/');
  if (!article) {
    return <section style={{
      background: '#fff',
      minHeight: '100vh',
      paddingTop: '68px'
    }} data-id="element-874" data-mp="cymh13r3efjz">
        <BlogBreadcrumb items={[{
        label: 'Alinova',
        to: '/'
      }, {
        label: 'Blog',
        to: '/blog'
      }, {
        label: 'No encontrado'
      }]} data-id="element-875" data-mp="8xu6862ko2ll" />
        <div style={{
        maxWidth: '600px',
        margin: '0 auto',
        padding: '80px 24px',
        textAlign: 'center'
      }} data-id="element-876" data-mp="3vd5en95hx7g8">
          <h1 style={{
          fontFamily: DS.font.heading,
          fontSize: '28px',
          fontWeight: 700,
          color: DS.color.ink,
          margin: '0 0 14px'
        }} data-id="element-877" data-mp="3lepob8eam27s">
            Artículo no encontrado
          </h1>
          <p style={{
          fontFamily: DS.font.body,
          fontSize: '15px',
          color: DS.color.body,
          margin: '0 0 28px'
        }} data-id="element-878" data-mp="3cg46jfgnar82">
            Es posible que el enlace sea incorrecto o el artículo ya no esté
            disponible.
          </p>
          <button type="button" onClick={goToArticles} style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: '8px',
          padding: '12px 26px',
          borderRadius: DS.radius.pill,
          border: 'none',
          background: DS.color.cta,
          boxShadow: '0 8px 26px rgba(0, 170, 212, 0.42)',
          color: '#fff',
          fontFamily: DS.font.body,
          fontSize: '14px',
          fontWeight: 700,
          cursor: 'pointer'
        }} data-id="element-879" data-mp="2xrb00mt76yx6">
            Volver al blog
          </button>
        </div>
      </section>;
  }
  return <section style={{
    background: '#fff',
    minHeight: '100vh',
    paddingTop: '68px'
  }} data-id="element-880" data-mp="1xrikqs91o6mm">
      <BlogBreadcrumb items={[{
      label: 'Alinova',
      to: '/'
    }, {
      label: 'Blog',
      to: '/blog'
    }, {
      label: truncate(article.title, 50)
    }]} data-id="element-881" data-mp="1ssfe53df1scj" />
      <div style={{
      padding: '48px 24px 80px'
    }} data-id="element-882" data-mp="26ln6wyd8gtvt">
        <ArticleDetail article={article} onBack={goToArticles} onHome={goHome} data-id="element-883" data-mp="22ja5un9flk5d" />
      </div>
    </section>;
}
export function ArticleDetailPage() {
  return <BlogContextProvider data-id="element-884" data-mp="19ttd1ohwg18m">
      <ArticleDetailPageContent data-id="element-885" data-mp="19ubf51r8t9og" />
    </BlogContextProvider>;
}